export default function UserSolidIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
        <path d="M17.9779 17.5784H1V14.9161C1 13.5261 4.12748 11.3417 9.68748 11.3417C15.2475 11.3417 17.9779 13.7743 17.9779 14.9161V17.5784Z" fill="#1E3665" />
        <circle cx="9.38925" cy="4.61679" r="3.86679" fill="#1E3665" />
    </svg>
  );
}
